import { render, staticRenderFns } from "./LaboratorioVisaoGeral.vue?vue&type=template&id=afa286fc&"
import script from "./LaboratorioVisaoGeral.vue?vue&type=script&lang=js&"
export * from "./LaboratorioVisaoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports